var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2458_7361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 9.33464C10.1111 9.33464 9.63889 9.14019 9.25 8.7513C8.86111 8.36241 8.66667 7.89019 8.66667 7.33464C8.66667 6.77908 8.86111 6.30686 9.25 5.91797C9.63889 5.52908 10.1111 5.33464 10.6667 5.33464C11.2222 5.33464 11.6944 5.52908 12.0833 5.91797C12.4722 6.30686 12.6667 6.77908 12.6667 7.33464C12.6667 7.89019 12.4722 8.36241 12.0833 8.7513C11.6944 9.14019 11.2222 9.33464 10.6667 9.33464ZM6.66667 13.3346V12.068C6.66667 11.8346 6.72222 11.6124 6.83333 11.4013C6.94444 11.1902 7.1 11.0235 7.3 10.9013C7.8 10.6013 8.33067 10.3764 8.892 10.2266C9.45333 10.0769 10.0449 10.0017 10.6667 10.0013C11.2884 10.0009 11.8802 10.076 12.442 10.2266C13.0038 10.3773 13.5342 10.6022 14.0333 10.9013C14.2333 11.0235 14.3889 11.1902 14.5 11.4013C14.6111 11.6124 14.6667 11.8346 14.6667 12.068V13.3346H6.66667ZM2 9.33464V8.0013H7.33333V9.33464H2ZM2 4.0013V2.66797H10V4.0013H2ZM7.4 6.66797H2V5.33464H8C7.84444 5.52352 7.71956 5.72908 7.62533 5.9513C7.53111 6.17352 7.456 6.41241 7.4 6.66797Z",
    fill: "#29C0BB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2458_7361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatient);
export default __webpack_public_path__ + "static/media/patient.a58a05080e19deda31a2bd2cde8a6109.svg";
export { ForwardRef as ReactComponent };